import { Download } from 'lucide-react'

export const VestingClaimIcon = Download
